module.exports = __webpack_public_path__ + "img/FR16000.795ef864.png";